// React Component
import React from 'react'

// App Component
import { AppLayout, HeaderLayout } from '../../layouts'
import { useHeaderLayoutCompanyData } from '../../hooks/useHeaderLayoutCompanyData'

// Features
import { ProcessCreate } from "../../features/process"

const CreateProcessView = () => {
    const headerProps = useHeaderLayoutCompanyData()

    return (
        <AppLayout>
            <>
                <HeaderLayout {...headerProps} />
                <div className="px-3 mt-2 h-100 ">
                    <div className='container mt-5'>
                        <ProcessCreate />
                    </div>

                </div>
            </>
        </AppLayout>
    )
}

export default CreateProcessView
